module.exports = __webpack_public_path__ + "static/media/image2.dffc5bd7.png";